import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'solar-journey',
    templateUrl: './journey.component.html',
    styleUrls: ['./journey.component.scss']
})
export class JourneyComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document) {
    }

    ngOnInit(): void {
    }
}
